var exports = {
  "Jr": "xa15a2ab7--05a0a8--type_block",
  "NW": "xa15a2ab7--05a0a8--type",
  "fF": "xa15a2ab7--05a0a8--type_block--without_icon",
};

module.exports = exports;
